import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import { useState, useMemo, useCallback } from 'react';

function useMap(initialValue) {
  var initialMap = useMemo(function () {
    return initialValue === undefined ? new Map() : new Map(initialValue);
  }, [initialValue]);

  var _useState = useState(initialMap),
      map = _useState[0],
      _set = _useState[1];

  var stableActions = useMemo(function () {
    return {
      set: function set(key, entry) {
        map.set(key, entry);

        _set(new Map(Array.from(map)));
      },
      setAll: function setAll(newMap) {
        _set(new Map(newMap));
      },
      remove: function remove(key) {
        map["delete"](key);

        _set(new Map(Array.from(map)));
      },
      reset: function reset() {
        return _set(initialMap);
      }
    };
  }, [map, _set]);
  var utils = Object.assign({
    get: useCallback(function (key) {
      return map.get(key);
    }, [map])
  }, stableActions);
  return [map, utils];
}

export default useMap;